import { FieldSchema } from "../../../../../../../../../_ovlclient/src/library/forms/sysformelement"
import {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../../../../../_ovlclient/src/library/table/table"

export type OfferingPos = {
  U_PosId?: number
  U_SKL?: string
  U_Width?: number
  U_Height?: number
  U_Length?: number
  U_Error?: string
  U_PosGroupDesc?: string
  U_DocEntry?: number
  U_Quantity?: number
}

export type TblOfferingColumn = keyof OfferingPos

export type TblOfferingPos = {
  [key: string]: OfferingPos
}
let mandatorySchema: FieldSchema = {
  nullable: false,
  nullValidatorOptions: { resetContext: "ValueChanged" },
}

let columns: { [key in keyof OfferingPos]: SYSColumnDef } = {
  U_PosId: {
    // we set explicitly to int because schema would be string...
    type: "int",
    sortable: true,
    schema: mandatorySchema,
  },
  U_Quantity: { sortable: true, schema: mandatorySchema },
  U_Width: { sortable: true, schema: mandatorySchema },
  U_Height: { sortable: true, schema: mandatorySchema },
  U_Length: { sortable: true, schema: mandatorySchema },
  U_SKL: {
    sortable: true,
    list: { displayField: "Code", valueField: "Code" },
    schema: mandatorySchema,
  },
  U_PosGroupDesc: { sortable: true, ui: {} },
}
export let tblOfferingPos: SYSTableDef = {
  id: "QUTOfferingPos",

  database: {
    dbInsertMode: "UDTAutoGUID",
  },
  server: {
    endpoint: "offeringpos",
  },
  columns,
  features: {
    focusToFirstEditableField: true,
    add: true,
    delete: true,
    edit: true,
    filter: true,
    page: true,
    autoRebuild: "AfterModifyOrDeleteOrAdd",
  },
  options: {
    tableGroupAggregates: {
      aggregates: [{ aggregateCode: "m3" }, { aggregateCode: "stk" }],
      disabled: false,
    },

    labelAndColumnTitleHandling: { translationPrefix: "QUTOfferingPosCol" },
    rendering: { controls: { fillSpaceIfNotVisible: false } },
    initial_sort: { field: "U_PosId", direction: "asc" },
    edit: {
      editType: "inline",
      noCancelOnEditFormIfFormStateWasInvalidWhenOpened: true,
      reserveSpaceForInlineValidationSummary: true,
    },
  },
}
